module.exports = __webpack_public_path__ + "624c1255/img/80000000-4.a6798164.png";